export default {
    //设置路由名称
    ["SET_ROUTER_NAME"](states, params) {
        states.routerName = params;
    },
    //改变loginModal的状态
    ["SET_LOGIN_STATUS"](states, params) {
        states.loginStatus = params;
    },
    //改变userInfo值
    ["SET_USER_INFO"](status, params) {
        status.userInfo = params;
    }
}




// WEBPACK FOOTER //
// ./src/store/navigation/mutations.js